import { PlatformAdminApi } from "@vintecc/capture-api-types/v1";
import captureApiConfiguration from "./configuration.api";

const platformAdmin = new PlatformAdminApi(captureApiConfiguration);

export default platformAdmin;
